import { Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { RolType } from '../../../shared/models/types/rol.types';
import { TranslatorService } from '../../../shared/services/utils/translator.service';

export class DropdownBaseComponent implements OnChanges, OnInit {
  itemsData: any = [];
  dropDownSettings: any;
  selectedItems = [];
  rolType = new RolType();

  @Input() singleSelection: boolean;
  @Input() placeholder: string;
  @Input() itemSelected: any;
  @Input() itemSelectedFunction: any;
  @Input() itemDeSelectedFunction: any;
  @Input() removeDefaultUnknown: any;
  @Input() context: any;
  @Input() itemsShowLimit: number;
  @Input() userRole: string;
  @Input() isPlanDay: boolean;
  @Input() isInCalendar: boolean;
  @Input() dropdownWithRules: any;
  @Input() disabled: boolean;

  constructor(readonly translator: TranslatorService) {
    if (!this.itemSelectedFunction) {
      this.itemSelectedFunction = function(): void {
        // console.warn();
      };
    }
    if (!this.itemDeSelectedFunction) {
      this.itemDeSelectedFunction = function(): void {
        // console.warn();
      };
    }
  }

  ngOnInit(): void {
    if (!this.removeDefaultUnknown) {
      this.itemsData.push({ id: '', name: this.translator.trans('dropdown.unknown') });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.selectedItems = [];

    if (this.isInCalendar && changes.itemSelected && changes.itemSelected.currentValue && (this.allowedUsers() || !this.isPlanDay)) {
      this.selectedItems.push(
        { id: changes.itemSelected.currentValue.id, name: `${changes.itemSelected.currentValue.name} ${changes.itemSelected.currentValue.lastName}` }
      );
    }

    if (!this.isInCalendar && this.singleSelection && changes.itemSelected && changes.itemSelected.currentValue) {
      this.selectedItems.push(
        { id: changes.itemSelected.currentValue.id, name: changes.itemSelected.currentValue.name }
      );
    }
    if (!this.singleSelection &&
      changes.itemSelected &&
      changes.itemSelected.currentValue &&
      this.itemSelected && this.itemSelected.length > 0) {
      this.selectedItems = this.itemSelected;

    }
  }

  clearSelectedItems() {
    this.selectedItems = [];
  }

  private allowedUsers() {
    return this.userRole === this.rolType.ROLE_USER || this.userRole === this.rolType.ROLE_BDC;
  }

  selectItem($event: any) {
    const item = this.itemsData.find(data => data.id === $event.id);
    this.itemSelectedFunction(item);
  }
}
